import { booleanToSimNaoEnum, simNaoEnumRecord } from 'components/form'
import { calculateIdadeGestacional } from 'util/atendimento/gestante/calculateIdadeGestacional'
import { isUndefinedOrNull } from 'util/checks'
import { formatDate } from 'util/date/formatDate'
import { parseNumber } from 'util/number'
import { isEmpty } from 'util/validation/Util'

import { arredondarIdadeGestacional } from '../../components/modals/medicoes/graficos/pre-natal/ganho-peso/util-graficoGanhoPeso'
import { MedicaoAntropometricaPreNatal } from '../../components/modals/medicoes/pre-natal/model-medicoesPreNatal'
import { renderGanhoPeso } from '../../components/modals/medicoes/pre-natal/util-medicoesPreNatal'
import { MedicaoField } from './model-acompanhamentoPreNatal'
import { calculatePercentilPesoGestacional } from './util-acompanhamentoPreNatal'

const NAO_INFORMADO = '—'

export const formatParenteses = (valor: string): string => {
  return valor ? `(${valor})` : ''
}

export const formatSemanas = (numeroSemanas: number): string => {
  return isUndefinedOrNull(numeroSemanas) ? NAO_INFORMADO : 'semana'.pluralizeAndConcatValue(numeroSemanas)
}

export const formatPercentil = (intervalo?: string): string => (intervalo ? ` - ${intervalo}` : '')

const formatarCampoMedicao = (medicaoField?: MedicaoField<any>, renderValor?: (valor: any) => string): string => {
  const valorMedicao = medicaoField?.medicao
  if (isEmpty(valorMedicao)) return NAO_INFORMADO

  const valorComoTexto = renderValor ? renderValor(valorMedicao) : String(valorMedicao)
  if (isEmpty(valorComoTexto)) return NAO_INFORMADO

  const dataComoTexto = formatDate(medicaoField?.dataMedicao)
  return `${valorComoTexto} | ${dataComoTexto}`
}

export const formatMedicaoDefault = (medicaoField: MedicaoField<any>, unidadeMedida = ''): string =>
  formatarCampoMedicao(medicaoField, (valor: string | number) => `${valor}${unidadeMedida}`)

export const formatGanhoPeso = (
  dataInicioGestacao: Date,
  medicaoField: MedicaoField<string | number>,
  medicaoReferencia: MedicaoAntropometricaPreNatal
): string =>
  formatarCampoMedicao(medicaoField, (valorAtual: number) => {
    const ganhoPeso = renderGanhoPeso(medicaoReferencia?.peso, valorAtual)
    if (ganhoPeso === NAO_INFORMADO) return null

    const dataMedicao = new Date(medicaoField?.dataMedicao)

    const idadeGestacional = calculateIdadeGestacional(dataInicioGestacao, dataMedicao).emDias
    const semanaAlvo = arredondarIdadeGestacional(idadeGestacional)

    const percentil = formatPercentil(
      calculatePercentilPesoGestacional(semanaAlvo, parseNumber(ganhoPeso), medicaoReferencia)
    )

    return `${ganhoPeso}kg${percentil}`
  })

export const formatMovimentacaoFetal = (medicaoField: MedicaoField<boolean>): string =>
  formatarCampoMedicao(medicaoField, (valorBooleano: boolean) => simNaoEnumRecord[booleanToSimNaoEnum(valorBooleano)])

export const formatEdema = (medicaoField: MedicaoField<string>): string =>
  formatarCampoMedicao(medicaoField, (valor: string) => formatParenteses(valor))

export const formatGlicemiaCapilar = (medicaoField: MedicaoField<string>): string =>
  formatarCampoMedicao(medicaoField, (valor: string) => `${valor} mg/dL`)
